//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';
import { isDefined } from '@utils/filterPredicates';

export const getUia = (state: ICuralateStore) => state.uiaModal;

export const getIsUiaPreferredCaptionEditingEnabled = createHasFeatureSelector(
  FeatureNames.UiaPreferredCaptionEditing,
);

export const getSelectedItemMetadata = createSelector(
  getUia,
  (uiaModal) => uiaModal.selectedItem.selectedItemMetadata,
);

export const getRootCuid = createSelector(
  getSelectedItemMetadata,
  (selectedItemMetadata) =>
    isDefined(selectedItemMetadata) ? selectedItemMetadata.rootCuid : undefined,
);
